import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
// import SingleNews from "./SingleNews/SingleNews";
import TableNews from "./TableNews/TableNews";
import { useGetManagementNewsQuery } from "../../api/admin/gestioneNewsApi";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables";
import { t } from "i18next";

const GestioneNews = () => {
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });

  const navigate = useNavigate();

  const {
    data: dataNews,
    isLoading: isLoadingNews,
    isFetching,
    refetch,
  } = useGetManagementNewsQuery({ page });

  const handleRefecthNews = () => {
    refetch();
  };
  return (
    <>
      {isLoadingNews ? (
        <CoreSpinner />
      ) : (
        <div className="w-full">
          <h2>{t("ManageNews")}</h2>
          <div className="flex space-x-4">
            <div className="">
              <CoreButtonHoverIcon
                testo={t("Refresh")}
                onClick={handleRefecthNews}
                className="text-blue-500 m-1"
                icon={<RefreshRoundedIcon className={"text-blue-500"} />}
              />
              <CoreButtonHoverIcon
                className="text-blue-800 m-1"
                icon={<AddBoxRoundedIcon className="text-blue-800" />}
                testo={t("News")}
                onClick={() => navigate(t("news"))}
              />
            </div>
          </div>

          <TableNews
            news={dataNews?.Data?.items}
            page={page}
            setPage={setPage}
            isLoading={isLoadingNews || isFetching}
            totalPages={
              Math.ceil(dataNews?.Data?.count / TABLE_ROWS_NUMBER) || 1
            }
          />
        </div>
      )}
    </>
  );
};

export default GestioneNews;
